import { inject, Injectable } from '@angular/core';
import { Observable, catchError, of, tap, throwError } from 'rxjs';
import { AuthService } from '@modules/auth/services/auth.service';
import { AppLanguage, LanguageService } from './language.service';
import { UserLanguageApiService } from './user-language-api.service';

/**
 * Zmiana języka z UI. Tłumaczenia przełączają się od razu, a zalogowanemu
 * kontu wybór zapisuje się w profilu — inaczej przy kolejnym logowaniu
 * AuthService przywróciłby język z bazy (applyUserPreference). Gdy zapis się
 * nie uda, wraca poprzedni język, żeby UI nie udawało zapisanego wyboru
 * (komunikat błędu pokazuje globalny HttpErrorInterceptor).
 */
@Injectable({ providedIn: 'root' })
export class PreferredLanguageService {
  private readonly languageService = inject(LanguageService);
  private readonly authService = inject(AuthService);
  private readonly api = inject(UserLanguageApiService);

  change(lang: AppLanguage): Observable<void> {
    const previous = this.languageService.getCurrentLanguage();
    if (lang === previous) {
      return of(undefined);
    }

    this.languageService.setLanguage(lang);
    if (!this.authService.getCurrentUser()) {
      return of(undefined);
    }

    return this.api.updatePreferredLanguage(lang).pipe(
      tap(() => this.authService.updateCurrentUser({ preferredLanguage: lang })),
      catchError((error: unknown) => {
        this.languageService.setLanguage(previous);
        return throwError(() => error);
      }),
    );
  }
}
